import { memberId } from './memberId';

export const isMemberLoggedIn = () => !!memberId;
